import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { iif, mergeMap, Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import {
  FinishRequest,
  MembershipStatusResponse,
  SelfApplicantResponse,
  SelfApplicationExistsResponse
} from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class FormFinishService {

  constructor(private http: HttpClient) { }

  finish(request: FinishRequest): Observable<string> {
    const forwardUrl = request.forwardUrl || "/";
    return this.getSelfApplicationExistsOnSubmission(request.submissionId)
      .pipe(
        // self application can be true if form is a membership + event registration, and the user fills out the membership section
        // and then selects self registration for the registration section
        mergeMap((response: SelfApplicationExistsResponse) => iif(() => response.selfApplicantExists, this.checkMembershipStatus(forwardUrl), of(forwardUrl) )),
        catchError((err: any) => {
          console.error("Failed to complete form finish", err);
          return of("/logout");
        })
      );
  }

  private checkMembershipStatus(forwardUrl: string): Observable<string> {
    return this.getMembershipStatus()
      .pipe(
        // status of 1 is when the membership status is Pending for the member type
        mergeMap((response: any) => iif(() => 1 === response.membershipStatus, of("/logout"), of(forwardUrl)))
      );
  }

  private getSelfApplicationExistsOnSubmission(submissionId: number): Observable<SelfApplicantResponse> {
    return this.http.get<SelfApplicantResponse>(`${window.location.origin}/ui-forms/v1/form/submission/${submissionId}/selfApplicant`);
  }

  private getMembershipStatus(): Observable<MembershipStatusResponse>{
    return this.http.get<MembershipStatusResponse>(`${window.location.origin}/ui-forms/v1/membershipStatus`);
  }
}
